import GjwImportFile from './src/GjwImportFile'

GjwImportFile.install = function(Vue) {
  Vue.component(GjwImportFile.name, GjwImportFile)
}

export default GjwImportFile
